/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'
import { candidateWhatsAppMessageDataStatusSchema } from './CandidateWhatsAppMessageDataStatusSchema'

export const candidateWhatsAppMessageDataSchema = z.object({
	id: z.string(),
	candidateId: z.string(),
	userId: z.string().nullable(),
	templateId: z.string().nullable(),
	templateName: z.string().nullable(),
	direction: z.string(),
	status: candidateWhatsAppMessageDataStatusSchema,
	recipientPhone: z.string(),
	content: z.string(),
	mediaUrls: z.array(
		z.object({
			url: z.string(),
			content_type: z.string(),
			filename: z.string().optional(),
			stored_media_id: z.string().optional(),
		}),
	).nullable(),
	templateParameters: z.array(z.string()).nullable(),
	errorCode: z.string().nullable(),
	errorMessage: z.string().nullable(),
	sentAt: z.iso.datetime().nullable(),
	deliveredAt: z.iso.datetime().nullable(),
	readAt: z.iso.datetime().nullable(),
	createdAt: z.iso.datetime(),
	updatedAt: z.iso.datetime(),
	isRead: z.boolean(),
	readByUserAt: z.iso.datetime().nullable(),
	readBy: z.array(z.object({ userId: z.string(), readAt: z.iso.datetime() })),
	isAutomated: z.boolean(),
})

export type CandidateWhatsAppMessageDataSchema = z.infer<typeof candidateWhatsAppMessageDataSchema>
